import Vue from "vue";
import App from "./App.vue";
import "./_private";
import router from "./_private/router";
import store from "./_private/store";
import i18n from "./_private/lang";
import e6Select from "e6select";
import "@/utils/map/gaodeKey.js"; // 引入地图相关
import axios from "axios";
import "@/assets/e6Font/iconfont.css";
import "@/assets/iconFont/iconfont.css";
import qs from "qs";
import dictSelect from "@/components/selectComponents/index"; // 字典表组件
import global from "@/utils/global"; // 全局弹框
import "e6yun-ui/lib/theme-chalk/time-line.css";
import "e6yun-ui/lib/theme-chalk/image.css";
import "e6yun-ui/lib/theme-chalk/resize-observer.css";
import "e6yun-ui/lib/theme-chalk/recycle-scroller.css";
import "e6yun-ui/lib/theme-chalk/vr-select-linkage.css";
// import "e6yun-ui/lib/theme-chalk/icon.css";
import {
  TimeLine,
  Video,
  Image,
  ImageViewer,
  VrSelectLinkage,
  VrSelect,
  RecycleScroller,
  ResizeObserver,
} from "e6yun-ui";

import Vue2OrgTree from "vue2-org-tree";

Vue.config.productionTip = false;

Vue.use(e6Select);

Vue.use(global);

Vue.use(dictSelect);

Vue.use(TimeLine);

Vue.use(Image);

Vue.use(ImageViewer);

Vue.use(VrSelect);

Vue.use(VrSelectLinkage);

Vue.use(RecycleScroller);

Vue.use(ResizeObserver);

Vue.use(Video);

Vue.use(Vue2OrgTree);

Vue.prototype.$axios = axios;

Vue.prototype.$qs = qs;

Vue.prototype.$GLOBAL_CONFIG = $GLOBAL_CONFIG;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
